import React, { PureComponent } from 'react';
import './index.less';

import flatten from 'lodash/flatten';

import PayoutRow from './payout-row';
import PayoutSubRow from './payout-sub-row';
import PayoutSumRow from './payout-sum-row';

class PayoutBody extends PureComponent {
	constructor(props) {
		super(props);

		this.state = {
			selected: null
		};
	}

	select(selected) {
		this.setState((state) => ({
			selected: state.selected === selected ? null : selected
		}));
	}

	getRows() {
		const { rows, actions, payoutSystem, isToPayColumnShouldBeShown } = this.props;

		const components = rows.reduce((components, row, i) => {
			const isOpen = this.state.selected === i;

			components.push(
				<PayoutRow
					isOpen={isOpen}
					row={row}
					payoutSystem={payoutSystem}
					isToPayColumnShouldBeShown={isToPayColumnShouldBeShown}
					actions={actions}
					onClick={() => this.select(i)}
					key={`row-${i}`}
				/>
			);

			components.push(row.payouts.map((payout, j) => (
				<PayoutSubRow
					isOpen={isOpen}
					isFirst={j === 0}
					payout={payout}
					payoutSystem={payoutSystem}
					isToPayColumnShouldBeShown={isToPayColumnShouldBeShown}
					actions={actions}
					key={`sub-row-${j}`}
				/>
			)));

			return components;
		}, []);

		components.push(
			<PayoutSumRow
				payouts={flatten(rows.map(row => row.payouts))}
				payoutSystem={payoutSystem}
				isToPayColumnShouldBeShown={isToPayColumnShouldBeShown}
				key='sum-row'
			/>
		);

		return components;
	}

	render() {
		return (
			<tbody className='payout-table--body'>
				{this.getRows()}
			</tbody>
		);
	}
}

export default PayoutBody;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-body/index.js